type Props = React.HTMLAttributes<HTMLSpanElement>;

const Close = (props: Props) => {
  return <span {...props}>X</span>;
};

export default Close;
